import { useTranslation } from 'react-i18next';

/**
 * Antes da r51 (classe do R50-VIS-M1): texto que nomeia o provedor da cobrança escolhe pelo provedor. A chave base é a do
 * Asaas; a do Sicredi troca "Asaas" no nome da chave por "Sicredi" (`geradaNoAsaas` > `geradaNoSicredi`) ou acrescenta
 * "Sicredi" (`ajuda` > `ajudaSicredi`); a neutra, sem provedor conhecido (sem cobrança e sem a regra, ou regra "nenhum"),
 * faz o mesmo com "Neutro". Toda chave do i18n que cita o Asaas tem a variante (`r51-pre-provedor-textos.test.ts`).
 */
export type ProvedorDoTexto = 'asaas' | 'sicredi' | 'nenhum' | null | undefined;

export function varianteDoProvedor(base: string, variante: 'Sicredi' | 'Neutro'): string {
  const i = base.lastIndexOf('.');
  const nome = base.slice(i + 1);
  return base.slice(0, i + 1) + (nome.includes('Asaas') ? nome.replace('Asaas', variante) : nome + variante);
}

/** A chave do texto para o provedor; a variante que não existe (texto sem nome de provedor) cai na base. */
export function chaveDoProvedor(base: string, provedor: ProvedorDoTexto, existe: (chave: string) => boolean): string {
  if (provedor === 'asaas') return base;
  const k = varianteDoProvedor(base, provedor === 'sicredi' ? 'Sicredi' : 'Neutro');
  return existe(k) ? k : base;
}

/** `tp('cobranca.ajuda', provedor)`: o `t` do Contas com a chave escolhida pelo provedor. */
export function useTextoDoProvedor() {
  const { t, i18n } = useTranslation('contas');
  return (base: string, provedor: ProvedorDoTexto, opcoes?: Record<string, unknown>) => t(chaveDoProvedor(base, provedor, (k) => i18n.exists(k, { ns: 'contas' })), opcoes);
}
